import React, { useEffect, useState } from 'react';
import './AllForLiveShow.scss';
import '../common.scss';
import { IComponentLiveShow } from '../../component';
import useTheme from '../hooks/useTheme';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import BigVideoWrapper from './BigVideoWrapper';

interface IAllForLiveShow extends IComponentLiveShow {
  rootStore?: RootStore;
}

function AllForLiveShow(props: IAllForLiveShow) {
  const theme = useTheme();
  const { title } = props;
  return (
    <div className={'all-for-liveshow decoratev2-comp-com'}>
      <div className="row-wrapper">
        {title ? (
          <div className="title" style={{ color: theme.h1Color }}>
            {title}
          </div>
        ) : null}
      </div>
      <BigVideoWrapper {...props}></BigVideoWrapper>
    </div>
  );
}
export default inject('rootStore')(observer(AllForLiveShow));
